module.exports = __webpack_public_path__ + "img/braendz-logo-tm-blue.01edbf1a.png";